<template>
    <div class="vue-phone-formatter">
        <a :href="phoneNumber | phoneFormatter">{{ phoneNumber }}</a>
    </div>
</template>

<script>
import PhoneNumberFormatter from "../mixins/PhoneNumberFormatter";

export default {
    name: "PhoneFormatter",

    mixins: [PhoneNumberFormatter],

    props: ['phoneNumber'],
}
</script>
